import { useState, useEffect } from 'react';

import get from 'lodash/get';
import { useCookies } from 'react-cookie';
import { siteId } from '../../sites';
import { siteIds } from '../../constants';

const useAgeVerification = (enabled = false) => {
  if (siteId === siteIds.Folkofolk || siteId === siteIds.Viinimaa) {
    enabled = true;
  }
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['user_age_verified']);

  const [isVerified, setIsVerified] = useState(true);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (get(cookies, 'user_age_verified') === 'yes') {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, [cookies, enabled]);

  return { isVerified, setIsVerified };
};

export default useAgeVerification;
